/**
 * Time: 2020-07-14 15:42:21
 * Author: zyl
 * Description: 图片编辑器，滑块
*/
'use strict';
angular.module('imgEditorCanvasModule').directive('slider', ['$parse', function($parse) {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            ngModel: '=', // 绑定滑块的值
            max: '@'
        },
        templateUrl: './components/directive/imgEditorCanvas/directive/slider/slider_tpl.html',
        link: function($scope, element, attrs) {

            // 滑块
            var Slider = (function(){
                var Slider = function(obj, value){
                    // obj滑块html元素
                    this.obj = obj;
                    this.slider = $(obj).find('span')[0];
                    this.slider.obj = this.obj;
                    this.slider.source = this;
                    this.value = value || 100;
                    this._x = 0;
                    this.down = false;// 鼠标是否按下
                    this.init();
                };
                Slider.prototype = {
                    init: function(){
                        var t = this,
                            obj = t.obj,
                            slider = t.slider;

                        t.max = obj.offsetWidth - slider.offsetWidth;
                        slider.style.left = t.value + 'px';
                        t._fnStart = t.BindAsEventListener(slider, t.mouseDown);
                        t._fnMove = t.BindAsEventListener(slider, t.mouseMove);
                        t._fnStop = t.Bind(slider, t.mouseUp);
                        t.addEventHandler(slider, 'mousedown', t._fnStart);
                        t.setValue(t.value).setSliderLeft();
                    },
                    setValue: function(value){

                        var t = this;

                        if (value > $scope.max) {t.value = $scope.max;} else if (value < 0) {t.value = 0;} else {t.value = value;}
                        $scope.ngModel = t.value;
                        safeApply();

                        return t;

                    },
                    setSliderLeft: function(){
                        // 0-100之间的数
                        var t = this,
                            obj = t.obj,
                            slider = t.slider,
                            value = t.value,
                            left = (Number(value) / $scope.max) * t.max;

                        slider.style.left = left + 'px';
                    },
                    mouseDown: function(e){
                        var t = this.source,
                            obj = t.obj,
                            slider = t.slider;

                        t.down = true;
                        t._x = e.pageX - slider.offsetLeft;
                        t.addEventHandler(document, 'mousemove', t._fnMove);
                        t.addEventHandler(document, 'mouseup', t._fnStop);
                    },
                    mouseMove: function(e){
                        var t = this.source,
                            obj = t.obj,
                            slider = t.slider,
                            left = 0;

                        if (t.down){
                            left = e.pageX - t._x;
                            if (left < 0) {left = 0;}
                            if (left > t.max) {left = t.max;}
                            // t.value = Math.floor((left/ t.max)*$scope.max);
                            t.setValue(Math.floor((left / t.max) * $scope.max));
                            slider.style.left = left + 'px';
                        }
                    },
                    mouseUp: function(e){
                        var t = this.source,
                            obj = t.obj;

                        t.down = false;
                        t.removeEventHandler(document, 'mousemove', t._fnMove);
                        t.removeEventHandler(document, 'mouseup', t._fnStop);
                    },

                    /*
                     功能：给给object元素绑定事件监听器fun,fun之后的参数做为fun的参数调用,改变fun的上下文
                     */
                    BindAsEventListener: function (object, fun) {
                        var args = Array.prototype.slice.call(arguments).slice(2);
                        return function (event) {
                            return fun.apply(object, [event || window.event].concat(args));
                        };
                    },

                    /*
                     功能：改变fun的上下文为object,fun之后的参数做为fun的参数调用，改变fun的上下文
                     */
                    Bind: function (object, fun) {
                        var args = Array.prototype.slice.call(arguments).slice(2);
                        return function () {
                            return fun.apply(object, args);
                        };
                    },

                    /*
                     功能： 给元素添加事件监听器
                     参数：
                     oTarget： 添加事件的html元素
                     sEventType： 事件类型，没有on
                     fnHandler： 事件处理函数
                     */
                    addEventHandler: function(oTarget, sEventType, fnHandler) {
                        if (oTarget.addEventListener) {
                            oTarget.addEventListener(sEventType, fnHandler, false);
                        } else if (oTarget.attachEvent) {
                            oTarget.attachEvent('on' + sEventType, fnHandler);
                        } else {
                            oTarget['on' + sEventType] = fnHandler;
                        }
                    },

                    /*
                     功能： 删除元素事件监听器
                     参数：
                     oTarget： 删除事件监听器的html元素
                     sEventType： 事件类型，没有on
                     fnHandler： 事件处理函数
                     */
                    removeEventHandler: function(oTarget, sEventType, fnHandler) {
                        if (oTarget.removeEventListener) {
                            oTarget.removeEventListener(sEventType, fnHandler, false);
                        } else if (oTarget.detachEvent) {
                            oTarget.detachEvent('on' + sEventType, fnHandler);
                        } else {
                            oTarget['on' + sEventType] = null;
                        }
                    }
                };
                return Slider;
            })();

            $scope.max = $scope.max || 100;
            $scope.slider = new Slider(element.find('.slider')[0], $scope.ngModel);

            $scope.$watch('ngModel', function(newValue, oldValue, scope){

                if (newValue != oldValue){
                    $scope.slider.setValue(newValue).setSliderLeft();
                }

            });

            /**
             * 安全脏循环检测
             */
            function safeApply(){
                if (!$scope.$$phase && ($scope.$root && !$scope.$root.$$phase)) {
                    $scope.$apply();
                }
            }

        }
    };
}]);
